<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col>
        <ServiceExpandable :state="state"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
import { mapState } from 'vuex';
export default {
  created() {
    this.items[0].text = this.branchName;
  },
  props: ['state'],
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId : state => state.Branch.branch_id,
      lang : state=> state.Branch.lang,
      services : state=> state.ServiceMenu.service_menu
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  methods:{

  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "SERVICE",
        to: "/service"
      }
    ],
    serviceList: [
      {
        id: "301",
        title: "membership",
        layout: "1"
      },
      {
        id: "302",
        title: "resource center",
        layout: "2"
      },
      {
        id: "303",
        title: "consult",
        layout: "3"
      },
      {
        id: "304",
        title: "venue hire",
        layout: "4"
      },
      {
        id: "305",
        title: "visit & service area",
        layout: "5"
      }
    ]
  }),
  components: {
    ServiceExpandable
  }
};
</script>

<style></style>
